export class ModalInfo {
  constructor(
    public text: string,
    public submitButtonText: string,
    public isNeedCancelingButton?: boolean,
    public cancelButtonText?: string,
  ) { }
}
